module.exports = __webpack_public_path__ + "img/cloud-clock.47c716b9.svg";